<template>
    <!-- zde se da vlozit neco na zobrazeni soucinu v hlavni casti -->
</template>

<script>
import {watch} from 'vue';

export default {
    props: {
        field: Object
    },
    setup({field}) {
        watch([field], ([newField], [oldField]) => {
            field.value = field.subFields.reduce((acc, subfield) => acc * (subfield.pricingType === 'none' ? subfield.value : 1), 1);
        }, {immediate: true});

        return {
        }
    }
}
</script>